<div>
  <div class="header"></div>
  <div class="content">
    <ul class="list-group">
      <li class="list-group-item">
        <span class="find-alerts-header">Find alerts from <b>Now</b> to </span>
        <icn-number-input
          [theme]="'dark'"
          [useDefaultHtmlInput]="true"
          [minLength]="0"
          [maxLength]="31"
          [min]="0"
          [max]="31"
          [step]="1"
          [value]="alertsSettings && alertsSettings.alertsTimespanInDays"
          (valueChange)="
            alertsSettings && (alertsSettings.alertsTimespanInDays = $event)
          "
        >
        </icn-number-input>
        <span class="find-alerts-header"> days</span>
        <!--<icn-dropdown class="daysFilter" [selectedContainerClass]="'width165 color-white'" [selectedClass]="'text-align-left'" [selectedValue]="alertsSettings && alertsSettings.alertsTimespanaInDays || 7"  (selectedValueChange)="updateDaysFilter($event)">
                    <icn-dropdown-item [title]="'Next 7 days'" [value]="7"></icn-dropdown-item>
                    <icn-dropdown-item   [title]="'Next 14 days'" [value]="14"></icn-dropdown-item>
                    <icn-dropdown-item  [title]="'Next Month'" [value]="31"></icn-dropdown-item>
                </icn-dropdown>-->
      </li>
    </ul>

    <ul class="list-group switchers">
      <li class="list-group-item">
        <icn-switch-toggle
          class="switcher"
          [theme]="'BLACK'"
          (isActiveChange)="updateGapAlertsSettings($event)"
          [(isActive)]="alertsSettings && alertsSettings.gapsReportEnabled"
        ></icn-switch-toggle>
        <span class="switcher-title">Gaps</span>
      </li>
      <li class="list-group-item">
        <icn-switch-toggle
          class="switcher"
          [theme]="'BLACK'"
          (isActiveChange)="updateMissingSubtitleAlertsSettings($event)"
          [(isActive)]="
            alertsSettings && alertsSettings.missingSubtitleReportEnabled
          "
        ></icn-switch-toggle>
        <span class="switcher-title">Missing Subtitles</span>
      </li>
      <li class="list-group-item">
        <icn-switch-toggle
          class="switcher"
          [theme]="'BLACK'"
          (isActiveChange)="updateMissingAudiosAlertsSettings($event)"
          [(isActive)]="
            alertsSettings && alertsSettings.missingAudiosReportEnabled
          "
        ></icn-switch-toggle>
        <span class="switcher-title">Missing Audios Tracks</span>
      </li>

      <li class="list-group-item">
        <icn-switch-toggle
          class="switcher"
          [theme]="'BLACK'"
          (isActiveChange)="updateEmptyContractAlertsSettings($event)"
          [(isActive)]="
            alertsSettings && alertsSettings.emptyContractReportEnabled
          "
        ></icn-switch-toggle>
        <span class="switcher-title">Empty Contracts</span>
      </li>
    </ul>
  </div>
  <div class="footer">
    <ichannel-button
      [label]="'APPLY'"
      class="apply-button"
      [customButtonStyle]="{
        'padding-top': '3px',
        'min-width': '53px',
        height: '23px',
        'padding-bottom': '3px',
        'font-size': '11px',
      }"
      [theme]="'BLACK'"
      (click)="applySettings()"
      >APPLY</ichannel-button
    >
  </div>
</div>
